import {texture} from "p3";
import GameScene from "../scenes/GameScene";
import {iswebfont, locale} from "../utils";

export default class ItemPopup extends PIXI.Container {
    constructor() {
        super();

        this._frame = null;
        this._banner = null;

        this._defaultTween = null;

        this.init();
    }

    init() {
        this.visible = false;

        this._frame = new PIXI.Sprite(texture("bg_found_object"));
        this._frame.position.set(0, -80);
        this._frame.anchor.set(0.5);
        this.addChild(this._frame);

        this._frame.icon = new PIXI.Sprite(texture("prop_collection_jar_blue_flowers_00"));
        this._frame.icon.position.y = -4;
        this._frame.icon.anchor.set(0.5);
        this._frame.addChild(this._frame.icon);

        //this._banner = new PIXI.Sprite(texture("title_found_object"));
        this._banner = new PIXI.NineSlicePlane(texture("title_found_object"), 20, 12, 20, 12);
        //this._banner.anchor.set(0.5);
        this.addChild(this._banner);

        if (!iswebfont()) {
            this._banner.titleLabel = new PIXI.BitmapText(locale('ui_new_item_found').toUpperCase(), {
                fontName: "Alghera Pro",
                fontSize: 32,
                align: "center",
                tint: 0xF5F4DF
            });
        } else {
            this._banner.titleLabel = new PIXI.Text(locale('ui_new_item_found').toUpperCase(), {
                fontFamily: "FredFredBurger",
                fontSize: 32,
                align: "center",
                fill: 0xF5F4DF
            });
        }
        this._banner.titleLabel.anchor.set(0.5);

        this._banner.width = Math.max(290, this._banner.titleLabel.width + this._banner.leftWidth + this._banner.rightWidth);
        this._banner.position.set(-this._banner.width/2, -this._banner.height/2);
        this._banner.titleLabel.position.set(this._banner.width/2, (this._banner.height/2) + !iswebfont() ? 35 : -1);

        this._banner.addChild(this._banner.titleLabel);
    }

    destroy() {
        this.stopAnimations();

        super.destroy({ children: true });
    }

    /**
     * @param {PIXI.Texture} texture
     */
    setItem(texture) {
        this._frame.icon.texture = texture;
    }

    /**
     * @param {number} [delay=0]
     * @return {Promise}
     */
    animateIn(delay= 0) {
        return new Promise((resolve) => {
            this.stopAnimations();

            this.visible = true;

            this._defaultTween = gsap.timeline({ delay: delay, onComplete: resolve });
            GameScene.active.addTween(this._defaultTween);

            this.scale.set(0);
            this._defaultTween.add(gsap.to(this.scale, 0.34, {
                x: 1,
                y: 1,
                ease: "back.out(2.4)"
            }), 0);

            this._frame.icon.scale.set(0);
            this._defaultTween.add(gsap.to(this._frame.icon.scale, 0.24, {
                x: 1,
                y: 1,
                ease: "back.out(2)"
            }), 0.2);
        });
    }

    /**
     * @param {number} [delay=0]
     * @return {Promise}
     */
    animateOut(delay= 0) {
        return new Promise((resolve) => {
            this.stopAnimations();

            this._defaultTween = gsap.to(this, 1, {
                delay: delay,
                alpha: 0,
                ease: Power2.easeInOut,
                onComplete: () => {
                    this.visible = false;
                    resolve();
                }
            });
            GameScene.active.addTween(this._defaultTween);
        });
    }

    stopAnimations() {
        if (this._defaultTween) {
            GameScene.active.removeTween(this._defaultTween, true);
            this._defaultTween = null;
        }
    }
}